import { render, staticRenderFns } from "./BaseMoreActions.vue?vue&type=template&id=25ed9582"
import script from "./BaseMoreActions.vue?vue&type=script&lang=js"
export * from "./BaseMoreActions.vue?vue&type=script&lang=js"
import style0 from "./BaseMoreActions.vue?vue&type=style&index=0&id=25ed9582&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports